export enum Status {
    AVAILABLE = "available",
    CANCELED = "canceled",
    CANCELLED = "cancelled",
    COMPLETE = "complete",
    COMPLETED = "completed",
    FAILED = "failed",
    INSTALLATION_FAILED = "installation_failed",
    IN_PROGRESS = "in_progress",
    IN_PRODUCTION = "in_production",
    NOT_AVAILABLE = "not_available",
    NOT_AVAILABLE_FOR_SUBSCRIPTION = "not_available_for_subscription",
    OPEN = "open",
    ORDERED = "ordered",
    PARTLY_DELIVERED = "partly_delivered",
    RECEIVED = "received",
    SUBSCRIBED = "subscribed",
    UNKNOWN = "unknown",
    UNSUBSCRIBED = "unsubscribed",
    UPDATE_AVAILABLE = "update_available",
    AllUpdatesSubscribed = "AllUpdatesSubscribed",
}
